module.exports = __webpack_public_path__ + "static/media/virgin-australia-480p.bac7fdae.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/virgin-australia-480p.mov
// module id = 511
// module chunks = 0